module.exports = __webpack_public_path__ + "img/stock2.87f51118.png";